export const ro = {
  nav: {
    home: 'Acasă',
    gallery: 'Galerie',
    book: 'Rezervă',
    memories: 'Amintiri',
    reviews: 'Recenzii',
    contact: 'Contact',
    login: 'Autentificare',
    signin: 'Autentificare',
    signup: 'Cont Nou',
    signIn: 'Autentificare',
    signUp: 'Cont Nou',
    account: 'Cont',
    myAccount: 'Contul Meu',
    logout: 'Deconectare',
    signOut: 'Deconectare',
    menu: 'Meniu',
    retreat: 'Refugiu Montan',
  },
  home: {
    stats: {
      altitude: 'Altitudine',
      guestRating: 'Evaluare Oaspeți',
      happyGuests: 'Oaspeți Fericiți',
      daysOpen: 'Zile Deschise',
    },
    amenities: {
      label: 'Facilități',
      title: 'Lux<br /><em>Montan</em>',
      subtitle: 'Fiecare detaliu a fost atent realizat pentru a îmbina confortul rafinat cu frumusețea brută a peisajului din Carpați.',
      list: [
        {
          title: 'Vederi Montane',
          desc: 'Vederi panoramice ale vârfurilor Carpaților se întind la nesfârșit de la fiecare fereastră și terasă.',
          detail: 'Trezește-te la răsărituri aurii care pictează creasta și încheie fiecare zi privind cum lumina se estompează în lumina stelelor.',
        },
        {
          title: 'Piscină Încălzită',
          desc: 'Ape calde sub cerul liber — scaldă-te sub stele în orice anotimp al anului.',
          detail: 'O piscină infinity încălzită pe tot parcursul anului, situată pe fundalul panoramei montane, cu iluminare subacvatică pentru înot la lăsarea serii.',
        },
        {
          title: 'Șemineu',
          desc: 'Flăcările zglobii și lumina caldă de chihlimbar creează cadrul perfect pentru seri de neuitat.',
          detail: 'Un șemineu mare din piatră ancorează spațiul de zi, având lemn de esență tare pregătit pentru fiecare seară.',
        },
        {
          title: 'Trasee Forestiere',
          desc: 'Ieși afară pe poteci de pădure antice ce așteaptă să fie explorate la răsărit sau apus.',
          detail: 'Kilometri de trasee marcate prin păduri vechi de fag și molid, de la plimbări line prin pajiști la urcușuri spre culmi.',
        },
        {
          title: 'Bucătărie Locală',
          desc: 'Mâncăruri tradiționale românești preparate cu ingrediente proaspete procurate din văile înconjurătoare.',
          detail: 'De la sarmale la mămăligă cu brânză, fiecare masă celebrează moștenirea transilvăneană cu ingrediente proaspete.'
        },
        {
          title: 'Observarea Stelelor',
          desc: 'Poluarea luminoasă zero dezvăluie un baldachin uluitor de stele vizibil de pe puntea de observare.',
          detail: 'O platformă de observare dedicată, cu scaune rabatabile și un telescop pentru explorarea Căii Lactee într-o claritate uimitoare.'
        }
      ]
    },
    experiences: {
      list: [
        'Întâlniri cu fauna sălbatică în păduri imaculate',
        'Cules de ciuperci cu ghizi locali',
        'Schi pe pârtiile din apropiere iarna',
        'Sesiuni de meditație la un răsărit de soare auriu',
        'Ateliere de bucătărie tradițională',
        'Excursii de pescuit în râuri de munte'
      ]
    },
    hero: {
      tagline: 'Un Sanctuar în Carpați',
      titleMain: 'Cabana',
      titleAccent: 'BURU',
      subtitle: 'Amplasată la 1.200 m, în păduri antice unde<br /> timpul se predă ritmului naturii',
      chipLocation: 'România',
      chipType: 'Refugiu Montan',
      chipEst: 'Est. 1947',
      cta: 'Rezervă Șederea',
      viewGallery: 'Vezi Galeria',
      rating: '4.9 din 120+ oaspeți',
      scroll: 'Derulați pentru a descoperi'
    },
    story: {
      label: 'Povestea Noastră',
      title: 'Unde Munții<br /><em>Întâlnesc Magia</em>',
      text1: 'Aflată la 1.200 de metri înălțime în Carpații românești, Cabana Buru îi întâmpină pe călători încă din generațiile trecute. Construită din lemn antic de molid și piatră locală, fiecare grindă spune o poveste despre măiestria montană transmisă de-a lungul secolelor.',
      text2: 'Fie că ești în căutare de aventură pe poteci accidentate sau te bucuri de serenitate lângă un foc zvelt, acesta este locul unde povestea ta continuă. Pădurea respiră, munții veghează, iar timpul curge într-un ritm diferit.'
    },
    footerCTA: {
      label: 'Fuga Ta Te Așteaptă',
      title: 'Gata pentru<br /><em>Găsirea Liniștii?</em>',
      subtitle: 'Alăturați-vă nouă deasupra norilor și descoperiți peisajul transilvănean de neuitat.',
      button: 'Găsește Date Disponibile'
    },
    experience: {
      label: 'Experiența Semnătură',
      title1: 'Îmbrățișează',
      title2: 'Sălbăticia',
      desc: 'Dincolo de porțile cabanei noastre, o lume a minunilor naturale te așteaptă. Parteneriatul nostru cu ghizii locali și conservatorii naturii îți permite să experimentezi Carpații în cea mai pură formă.'
    },
    glance: {
      label: 'Locația',
      title1: 'Cabana',
      title2: 'În Detaliu',
      propertyType: {
        label: 'Tip Proprietate',
        value: 'Cabana Întreagă (Privat)'
      },
      capacity: {
        label: 'Capacitate',
        value: 'Până la 8 Oaspeți'
      },
      location: {
        label: 'Locație',
        value: 'Munții Apuseni, RO'
      },
      checkInOut: {
        label: 'Check-in / Check-out',
        value: '15:00 / 11:00'
      },
      availability: {
        label: 'Disponibilitate',
        value: 'Deschis Tot Anul'
      },
      cancellation: {
        label: 'Anulare',
        value: 'Gratuită cu 14 zile înainte'
      },
      highlights: {
        title: 'Puncte Forte ale Cabanei',
        items: [
          'Piscină infinity încălzită și saună',
          'Bucătărie gourmet complet echipată',
          'Șemineu cu lemne uscate',
          'Wi-Fi de mare viteză peste tot',
          'Parcare privată în incintă',
          'Coș de bun venit cu produse locale',
          'Jocuri de societate și un colț de lectură',
          'Punte de observație și telescop'
        ]
      },
      ctaLabel: 'Începând de la',
      ctaPrice: '120€',
      ctaPerNight: '/noapte',
      ctaButton: 'Verifică Datele'
    },
    cta: {
      badge: 'Rezervare Directă',
      title1: 'Următoarea Ta',
      title2: 'Aventură',
      desc: 'Rezervați-vă data astăzi și asigurați-vă un refugiu în mijlocul munților acoperiți de nori. Tarifele noastre includ toate facilitățile.',
      button: 'Găsește Disponibilitate',
      reassurance: 'Plată online securizată și confirmare instantă'
    },
    attractions: {
      label: 'Atracții din Apropiere',
      title1: 'Descoperă Ce E',
      title2: 'Prin Zona Buru',
      subtitle: 'De la chei spectaculoase și puncte de belvedere, la saline și sate cu istorie — câteva idei de excursii de o zi, ușor accesibile.',
      tags: {
        nature: 'Natură',
        hike: 'Drumeție',
        waterfall: 'Cascadă',
        viewpoint: 'Belvedere',
        peak: 'Vârf',
        unique: 'Unic',
        village: 'Sat',
        history: 'Istorie',
        culture: 'Cultură',
        museum: 'Muzeu',
      },
      items: {
        cheileBorzesti: {
          name: 'Cheile Borzești',
          desc: 'O cheie liniștită aproape de Buru, potrivită pentru o plimbare scurtă în natură și aer curat.',
        },
        cheileTurzii: {
          name: 'Cheile Turzii',
          desc: 'Unele dintre cele mai spectaculoase chei din Transilvania — trasee, stânci și priveliști ample.',
        },
        cascadaCiucas: {
          name: 'Cascada Ciucaș',
          desc: 'O cascadă pitorească — ideală pentru o ieșire ușoară și un picnic relaxant.',
        },
        piatraSecuiului: {
          name: 'Piatra Secuiului',
          desc: 'Stânca emblematică deasupra Rimetei — urcarea răsplătește cu panorame superbe la răsărit sau apus.',
        },
        munteleMare: {
          name: 'Muntele Mare',
          desc: 'O zi clasică în Apuseni — drumuri prin pădure, pajiști alpine și orizonturi largi.',
        },
        salinaTurda: {
          name: 'Salina Turda',
          desc: 'Salină celebră transformată într-un spațiu subteran spectaculos — deosebită și potrivită pentru toată familia.',
        },
        rimetea: {
          name: 'Satul Rimetea',
          desc: 'Un sat superb păstrat, cu case albe și moștenire maghiară, la poalele Pietrei Secuiului.',
        },
        cetateaColtesti: {
          name: 'Cetatea Colțești',
          desc: 'Ruinele unei fortărețe medievale, cu o plimbare frumoasă pe creastă și cadre excelente pentru fotografii.',
        },
        woodenChurchBuru: {
          name: 'Biserica de Lemn din Buru',
          desc: 'Un reper local cu meșteșug tradițional și o atmosferă calmă, autentică.',
        },
        ethnographicMuseumRimetea: {
          name: 'Muzeul Etnografic din Rimetea',
          desc: 'Un muzeu mic ce aduce la viață tradițiile locului — meșteșuguri, port popular și istorie rurală.',
        },
      },
    }
  ,
  },
  footer: {
    brand: {
      tagline: 'Unde munții te primesc acasă',
      desc: 'Ascunsă la 1.200m în Carpați, cabana noastră oferă un refugiu montan autentic, înconjurat de păduri antice și vârfuri uluitoare.'
    },
    navigate: {
      title: 'Navigare',
      home: 'Acasă',
      gallery: 'Galerie',
      book: 'Rezervă o Ședere',
      reviews: 'Recenzii',
      contact: 'Contact',
    },
    experience: {
      title: 'Experiență',
      views: 'Vederi Montane',
      trails: 'Trasee Forestiere',
      cuisine: 'Bucătărie Locală',
      stargazing: 'Observarea Stelelor',
    },
    guest: {
      title: 'Oaspete',
      signIn: 'Autentificare',
      register: 'Înregistrare',
      account: 'Contul Meu',
      writeReview: 'Scrie o Recenzie',
    },
    bottom: {
      rights: '© 2026 Cabana Buru. Toate drepturile rezervate.',
      madeWith: 'Realizat cu'
    }
  },
  contact: {
    hero: {
      tagline: 'Ne-ar plăcea să auzim de la tine',
      title1: 'Contactează-ne',
      title2: 'Acum',
      sub: 'Contactează-ne oricând — ușile și liniile noastre telefonice sunt mereu deschise'
    },
    methods: {
      title1: 'Alege',
      title2: 'Calea',
      subtitle: 'Alege ce e mai convenabil — suntem la fel de bucuroși pe toate canalele',
      list: [
        {
          label: 'Apel Telefonic',
          description: 'Disponibil zilnic de la 8:00 la 22:00 (ora României)',
          action: 'Sună Acum'
        },
        {
          label: 'WhatsApp',
          description: 'Răspunsuri rapide — de obicei în 30 de minute pe timpul zilei',
          action: 'Deschide Chat'
        },
        {
          label: 'Email',
          description: 'Răspundem în 24 de ore — perfect pentru întrebări detaliate',
          action: 'Trimite Email'
        }
      ]
    },
    faq: {
      tagline: 'Ai Întrebări?',
      title1: 'Întrebări',
      title2: 'Frecvente',
      sub: 'Găsește răspunsuri rapide la cele mai comune întrebări despre șederea ta.',
      list: [
        {
          q: 'Care este cel mai bun moment pentru a vizita?',
          a: 'Fiecare anotimp are magia sa. Vara este perfectă pentru drumeții și înot, toamna pentru frunzișul auriu, iarna pentru zăpadă și confort, iar primăvara pentru pajiștile cu flori sălbatice.'
        },
        {
          q: 'Cum ajung la cabană?',
          a: 'Suntem accesibili cu mașina pe DN7A. Ultimii 2 km sunt pe un drum forestier. Oferim direcții detaliate și coordonate GPS la rezervare. Preluarea de la aeroportul din Sibiu poate fi aranjată.'
        },
        {
          q: 'Există Wi-Fi disponibil?',
          a: 'Da, avem Wi-Fi stabil în întreaga cabană. Totuși, încurajăm oaspeții să se deconecteze și să se bucure de aerul de munte!'
        },
        {
          q: 'Pot aduce animalul de companie?',
          a: 'Iubim oaspeții blănoși! Câinii sunt bineveniți cu notificare prealabilă. Avem o curte îngrădită și trasee în apropiere perfecte pentru plimbări.'
        },
        {
          q: 'Care este politica de anulare?',
          a: 'Anulare gratuită cu până la 7 zile înainte de check-in. Anulările cu mai puțin de 7 zile primesc o rambursare de 50%. Înțelegem că planurile se schimbă — doar contactați-ne!'
        }
      ]
    },
    location: {
      tagline: 'Ajungând Aici',
      title1: 'Găsește',
      title2: 'Calea',
      address: 'DN7A km 45, Munții Apuseni, România',
      desc: 'Cuibărită în inima pădurii, coordonatele noastre exacte îți vor rezerva un colț de liniște. Urmează calea spre seninătate.'
    },
    info: {
      responseTime: {
        label: 'Timp de Răspuns',
        value: 'Sub 30 min'
      },
      location: {
        label: 'Locație',
        value: 'Munții Carpați, România'
      },
      availability: {
        label: 'Disponibilitate',
        value: 'Deschis 365 zile pe an'
      }
    },
    mapDetails: {
      address: {
        label: 'Adresă',
        value: 'Cabana Buru, Munții Șureanu, Jud. Alba, România'
      },
      coords: {
        label: 'Coordonate',
        value: '45.6123° N, 23.4567° E'
      },
      note: {
        label: 'Notă',
        value: 'Trimitem indicații detaliate cu puncte GPS după rezervare'
      },
      alt: '1.200m altitudine'
    },
    bottom: {
      title: 'Abia așteptăm să te primim',
      desc: 'Fie că e prima vizită sau a zecea, munții te cheamă mereu',
      whatsapp: 'Scrie-ne pe WhatsApp',
      call: 'Sună-ne Acum'
    }
  },
  memories: {
    label: 'Un Jurnal Vizual',
    title: 'Albumul cu Amintiri',
    subtitle: 'Împărtășește momentele preferate cu ceilalți oaspeți.',
    stats: {
      photos: 'Fotografii',
      contributors: 'Contribuitori',
      likes: 'Aprecieri'
    },
    addJournal: 'Adaugă la Jurnal',
    uploadPrompt: 'Încarcă cele mai bune momente de la Cabana Buru',
    guestNotice: 'Navigați ca vizitator.',
    signInUpload: 'Conectați-vă',
    toUpload: 'pentru a încărca.',
    caption: 'Descriere',
    captionPlaceholder: 'ex. Cafeaua de dimineață pe terasă',
    photos: 'Fotografii',
    dropPhotos: 'Faceți clic sau trageți fotografiile aici',
    supportFiles: 'Suportă JPG, PNG, WebP',
    maxImages: 'Maxim 10 imagini, până la 6MB pe fișier.',
    publishing: 'Se încarcă...',
    publishButton: 'Publică Amintiri',
    latest: 'Ultimele Contribuții',
    noUploads: 'Nicio încărcare încă. Fii primul care împărtășește o amintire.',
    like: 'Apreciază',
    liked: 'Apreciat',
    by: 'de'
  },
  book: {
    heroLabel: 'Rezervări',
    heroTitleMain: 'Rezervă',
    heroTitleAccent: 'Refugiul Montan',
    heroSub: 'Selectează datele tale și evadează în Carpați',
    days: ['Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ', 'Du'],
    months: ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'],
    available: 'Disponibil',
    booked: 'Rezervat',
    selected: 'Selectat',
    signInReq: 'Autentificare Necesară',
    signInDesc: 'Vă rugăm să vă autentificați pentru a face o rezervare la Cabana Buru.',
    signInBtn: 'Autentificare',
    noAccount: 'Nu ai un cont?',
    createOne: 'Creează unul',
    yourReservation: 'Rezervarea Ta',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    selectDate: 'Selectează data',
    guests: 'Oaspeți',
    specialNotes: 'Cerințe speciale',
    notesPlaceholder: 'Alergii alimentare, ocazii speciale etc.',
    summary: 'Rezumat',
    nights: 'nopți',
    total: 'Total',
    confirmBtn: 'Confirmă Rezervarea',
    confirming: 'Se confirmă...',
    successMsg: 'Rezervarea ta a fost confirmată! Așteptăm cu nerăbdare să te primim.',
    errorRange: 'Perioada selectată se suprapune cu o rezervare existentă.',
    errorDates: 'Vă rugăm să selectați datele de check-in și check-out.',
    errorGeneric: 'Ceva nu a funcționat corect.'
  },
  account: {
    heroTag: 'Contul Meu',
    welcomeBack: 'Bine ai revenit',
    traveler: 'Călătorule',
    heroDesc: 'Gestionează-ți retragerile montane și urmărește-ți călătoria cu noi',
    statsTotalStays: 'Șederi Totale',
    statsNights: 'Nopți Petrecute',
    statsUpcoming: 'Urmează',
    statsGuests: 'Oaspeți Găzduiți',
    statsFavMonth: 'Luna Preferată',
    loyaltyTag: '🌿 Program de Loialitate',
    loyaltyDiscount: 'REDUCERE',
    loyaltyMoreStays: 'șederi până la',
    loyaltyMoreStay: 'ședere până la',
    loyaltyStays: 'șederi',
    profileTag: '👤 Profil',
    profileSignOut: 'Deconectare',
    profileEmail: 'Email',
    profilePhone: 'Număr de Telefon',
    profileName: 'Nume Complet',
    profileJoined: 'Membru Din',
    profileSave: 'Salvează Modificările',
    profileSaving: 'Se salvează...',
    tabsUpcoming: 'Viitoare & Active',
    tabsPast: 'Șederi Anterioare',
    tabsCancelled: 'Anulate',
    bookingId: 'ID Rezervare',
    bookingCheckIn: 'Check-in',
    bookingCheckOut: 'Check-out',
    bookingGuests: 'Oaspeți',
    bookingTotal: 'Total',
    bookingCancelPrompt: 'Anulați această rezervare?',
    bookingCancelBtn: 'Anulează Rezervarea',
    bookingCancelledBtn: 'Anulată',
    bookingNoStays: 'Nu au fost găsite șederi în această categorie.',
    statusUpcoming: 'Urmează',
    statusActive: 'Activ',
    statusCompleted: 'Finalizat',
    statusCancelled: 'Anulat',
    profileSuccess: 'Profil actualizat cu succes!',
    months: ['Ian','Feb','Mar','Apr','Mai','Iun','Iul','Aug','Sep','Oct','Nov','Dec']
  }
};
